export const ShowcasesItemTypes = {
  products: 1,
  services: 2,
  prices: 3,
}
